<template>
  <transition name="el-fade-in-linear">
    <div class="calender-schedule-media-component">
      <hi-dialog
        v-show="!editModal"
        class="media-dialog"
        title="Media"
        @close="close()"
      >
        <div class="big-image-container">
          <crop-item
            ref="crop"
            :key="index"
            v-for="(item, index) in images"
            class="image"
            :style="{ 'z-index': index === selectIndex ? 2 : 1 }"
            :model="item.crop"
            :media="item"
            @changeImg="changeImg"
          ></crop-item>
          <!-- <div class="mul-btn"
               @click="addImageClick">
          </div> -->
          <template v-if="images[selectIndex].type !== 2">
            <!--只有一张图才能切换全屏模式 story永远都不是-->
            <div
              v-if="images.length === 1 && !story"
              @click="switchFull"
              class="crop-icon full"
            ></div>
            <div @click="zoom(1)" class="crop-icon enlarged"></div>
            <div @click="zoom(-1)" class="crop-icon shrink"></div>
            <div @click="rotate" class="crop-icon rotate">️</div>
          </template>
        </div>
        <div :class="{ hide: !mul }" class="mul-image-container">
          <div v-for="(image, index) in images" :key="image.id">
            <div
              class="image"
              @click="selectIndex = index"
              :class="{ select: index === selectIndex, story }"
            >
              <media-crop-thumbnails
                :model="image"
                :key="image.id"
              ></media-crop-thumbnails>
              <div class="mask">
                <div
                  class="icon"
                  v-show="images.length > 1"
                  @click.stop="removeImage(index)"
                ></div>
              </div>
            </div>
          </div>
        </div>
        <div class="bottom-container">
          <hi-button type="text" style="padding: 0" @click.native="editClick"
            >Edit</hi-button
          >
          <hi-button
            type="text"
            style="padding: 0"
            v-if="only"
            @click.native="cropSaveClick"
            >Done</hi-button
          >
        </div>
      </hi-dialog>
      <hi-dialog
        v-show="editModal"
        title="Apphi Library"
        @close="close()"
        class="media-library-dialog"
      >
        <img
          v-show="!only"
          @click="editModal = false"
          class="back-icon"
          slot="left"
          src="../../../../../public/images/common/Back@3x.png"
        />
        <div style="flex: 1; overflow: auto" id="apphi-library-modal">
          <div class="library-image-container">
            <div
              @click="selectMedia(image)"
              :class="{ select: image.index !== undefined }"
              :key="image.id"
              v-for="image in libraries"
              v-lazy:background-image="image.coverUrl"
              class="image"
            >
              <div v-if="image.type === 2" class="video-icon"></div>
              <div class="icon">{{ image.index }}</div>
            </div>
          </div>
          <div style="width: 100%; padding: 20px; text-align: center">
            <el-button
              v-show="!mediaListLoading && !mediaLibraryList.end"
              size="mini"
              style="width: 100%"
              @click="loadMoreMedia()"
              >Load more</el-button
            >
            <div
              v-show="mediaLibraryList.end"
              style="color: rgb(140, 140, 140)"
            >
              end
            </div>
            <div v-show="mediaListLoading">
              <i class="el-icon-loading"></i> Loading
            </div>
          </div>
        </div>
        <div class="bottom-container">
          <upload-btn target="#apphi-library-modal">
            <hi-button type="text">Upload</hi-button>
          </upload-btn>
          <hi-button @click.native="saveSelect">Select</hi-button>
        </div>
      </hi-dialog>
    </div>
  </transition>
</template>
<style lang="less">
.dragClass {
  background: black;

  .image {
    opacity: 1 !important;
  }
}
</style>
<style lang="less" scoped>
@import "../../../../assets/style/theme";

.calender-schedule-media-component {
  .media-dialog {
    width: 374px;
    margin-right: 5px;
    display: flex;
    flex-direction: column;
    min-height: inherit;
    max-height: inherit;

    .big-image-container {
      background: #e5e5e5;
      position: relative;
      height: 375px;
      overflow: hidden;

      .image {
        height: 375px;
        width: 375px;
        position: absolute;
        left: 0;
        top: 0;
      }

      .mul-btn {
        position: absolute;
        right: 20px;
        bottom: 20px;
        width: 55px;
        height: 55px;
        background-size: contain;
        background-image: url("../../../../../public/images/crop/Photo_Select_Album@3x.png");
        cursor: pointer;
        z-index: 3;
        &:hover {
          opacity: 0.7;
        }
      }

      .crop-icon {
        width: 25px;
        height: 25px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        color: white;
        background-size: contain;
        z-index: 3;
        position: absolute;
        left: 25px;

        &.full {
          background-image: url("../../../../../public/images/crop/Cut@3x.png");
          height: 55px;
          width: 55px;
          position: absolute;
          bottom: 20px;
          left: 20px;
        }

        &.enlarged {
          background-image: url("../../../../../public/images/crop/Edit_Media_B_M@3x.png");
          position: absolute;
          top: 25px;
        }

        &.shrink {
          background-image: url("../../../../../public/images/crop/Edit_Media_S_M@3x.png");
          top: 75px;
        }

        &.rotate {
          color: transparent;
          top: 125px;
          background-image: url("../../../../../public/images/crop/Rotate_M@3x.png");
        }
        &:hover {
          opacity: 0.7;
        }
      }
    }

    .mul-image-container {
      overflow-x: auto;
      width: 374px;
      white-space: nowrap;
      height: 120px;
      overflow-y: hidden;
      display: flex;
      padding: 5px;

      &.hide {
        height: 0;
        padding: 0;
      }

      .a {
        background: #e5e5e5;
      }

      .image {
        width: 100px;
        height: 100px;

        &.story {
          width: 56px;
        }

        margin: 5px;
        background: #e5e5e5;
        cursor: pointer;
        position: relative;

        &.select .mask,
        &:hover .mask {
          display: block;
        }

        &.select {
          background: rgba(0, 0, 0, 0.5);
        }

        .mask {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.5);
          z-index: 1;
          display: none;

          .icon {
            position: absolute;
            right: 3px;
            top: 3px;
            color: white;
            height: 20px;
            width: 20px;
            background-position: center;
            background-size: contain;
            background-image: url("../../../../../public/images/common/Close_w@3x.png");
            background-repeat: no-repeat;
          }
        }
      }
    }

    .bottom-container {
      padding: 0 20px;
      height: 64px;
      display: flex;
      align-items: center;
      border-top: 1px solid #e5e5e5;
      justify-content: space-between;
    }
  }

  .media-library-dialog {
    width: 374px;
    margin-right: 5px;
    display: flex;
    flex-direction: column;
    height: 730px;

    .back-icon {
      width: 24px;
      height: 24px;
    }

    .library-image-container {
      display: flex;
      overflow: auto;
      width: 374px;
      flex-wrap: wrap;

      .image {
        width: 124px;
        height: 124px;
        margin-bottom: 1px;
        margin-right: 1px;
        background-size: cover;
        background-position: center;
        cursor: pointer;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;

        .video-icon {
          width: 55px;
          height: 55px;
          z-index: 2;
          background-size: cover;
          background-image: url("../../../../../public/images/schedule_posts/list/video.png");
        }

        &:nth-child(3n) {
          margin-right: 0;
        }

        .icon {
          border: 1px solid white;
          width: 22px;
          height: 22px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.2);
          position: absolute;
          bottom: 10px;
          right: 10px;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        &.select .icon {
          background: @color-primary;
          color: white;
          border-color: @color-primary;
          font-size: 12px;
          line-height: 1;
        }
      }
    }

    .bottom-container {
      padding: 0 20px;
      height: 64px;
      border-top: 1px solid #e5e5e5;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .upload-menu {
      position: absolute;
      left: 5px;
      bottom: 45px;
      background: white;
      border-radius: 3px;
      padding: 5px 0;

      &:after,
      &:before {
        left: 17%;
      }

      .item {
        display: flex;
        align-items: center;
        padding: 12px;
        cursor: pointer;

        .title {
          font-size: 14px;
          white-space: nowrap;
          margin-left: 10px;
        }

        i {
          font-size: 16px;
        }

        &:last-child {
          margin-bottom: 0;
        }

        &:hover {
          background: @color-primary;
          color: white;
        }
      }
    }
  }
}
</style>

<script>
import hiDialog from "../../../common/dialog/Index.vue";
import hiButton from "../../../common/button/Index";
import { loadMore, setCropImages } from "../../../../service/media";
import { mapGetters } from "vuex";
import { MEDIA_LIBRARY_LIST } from "../../../../store/mutation-types";
import MediaCropThumbnails from "../../crop/Thumbnail";
import { showErrorMsg } from "../../../../utils/errors";
import uploadBtn from "../../../library_menu/UploadBtn";
import CropItem from "../../crop/CropItem";
import { getImageCropPercentage } from "../../../../utils/media";
import _ from "lodash";
export default {
  name: "CalenderScheduleMediaComponent",
  components: { CropItem, hiDialog, hiButton, MediaCropThumbnails, uploadBtn },
  props: {
    images: {
      type: Array,
      default: () => [],
    },
    story: {
      type: Boolean,
      default: false,
    },
    publisherList: {
      type: Array,
    },
  },
  methods: {
    /** 图片发生改变 */
    changeImg() {
      this.$parent.form.changeImg = true;
    },
    /**
     * 横向满屏 纵向满屏切换
     */
    switchFull() {
      this.$refs.crop[this.selectIndex].switchFull(0.1);
    },
    /**
     * 缩放
     * @param scale 缩放
     */
    zoom(scale) {
      if (scale === 1) {
        this.$refs.crop[this.selectIndex].shrink(0.1);
      } else if (scale === -1) {
        this.$refs.crop[this.selectIndex].shrink(-0.1);
      }
    },
    /**
     * 旋转
     */
    rotate() {
      this.$refs.crop[this.selectIndex].rotate();
    },
    /**
     * 关闭点击事件
     */
    close() {
      if (this.only) {
        this.$parent.close();
      }
      this.$parent.showMediaModal = false;
    },
    /**
     * 页面重新加载
     */
    async reload() {
      await loadMore({ first: true });
    },
    async selectMedia(m) {
      const index = this.copy.findIndex((i) => i.id === m.id);
      if (this.twitter) {
        let selectType = null;
        if (this.copy.length !== 0) {
          // 计算之前的选择
          selectType = this.copy[0].type; // 1:image 2:video
        } else {
          if (m.type === 2 && !m.postVideo) {
            const msg = `Due to Instagram POST limitations, Apphi Desktop only supports .mp4 video format with ratios between 4:5 to 16:9. Video must be between 3 to 60 seconds. \n\nYou can use Apphi App to edit your video, change cover, schedule and upload directly.`;
            this.$bus.$emit("showDownload", { msg });
            return;
          }
          // 如果一个都没选中那就直接添加
          this.copy.push({ ...m });
          return;
        }
        if (index === -1) {
          let showMsg = false;
          if (selectType === 1) {
            // 如果之前选择的图片则可以继续添加4张图片
            if (this.copy.length === 4 || m.type === 2) {
              showMsg = true;
            }
          } else {
            showMsg = true;
          }
          if (showMsg) {
            await this.$alert.show({
              text: "Only supports 1 video or max 4 photos on Twitter.",
              yesText: "OK",
            });
            return;
          }
          this.copy.push({ ...m });
        } else {
          this.copy.splice(index, 1);
        }
        return;
      }
      // 不能选择视频
      if (m.type === 2) {
        this.$bus.$emit("showDownload");
        return;
      }
      if (index === -1) {
        if (this.copy.length === 10) {
          // 最多只能添加10个
          await this.$alert.show({
            text: "Max 10 media each time.",
            yesText: "OK",
          });
          return;
        }
        this.copy.push({ ...m });
      } else {
        if (this.copy.length === 1) return;
        this.copy.splice(index, 1);
      }
    },
    /**
     * 添加图片
     */
    addImageClick() {
      // 判断如果包含视频不允许操作
      if (!this.hasNoVideo) {
        this.$bus.$emit("showDownload");
        return;
      }
      this.copy = [...this.images];
      this.editModal = true;
    },
    editClick() {
      // 判断如果包含视频不允许操作
      if (!this.hasNoVideo) {
        this.$bus.$emit("showDownload");
        return;
      }
      this.$parent.openCropGroup();
    },
    /**
     * 删除图片
     */
    removeImage(index) {
      // 判断选中项是否为最后一项
      if (this.images.length - 1 === this.selectIndex) {
        this.selectIndex--;
      }
      this.images.splice(index, 1);
      if (this.images.length === 1 && !this.story) {
        this.images[0].crop.lock = false;
      }
    },
    /**
     * 保存选中图片
     */
    async saveSelect() {
      const result = _.cloneDeep(this.copy);
      const loading = this.$loading();
      try {
        // 判断如果copy的数量>1则说明需要统一裁切比
        if (result.length > 1) {
          result.forEach((img) => {
            img.crop.lock = true;
            img.crop.percentage = getImageCropPercentage({
              model: this.images[0].crop,
            });
          });
        } else {
          result[0].lock = false;
          this.copy[0].lock = false;
        }
        if (this.story) {
          result.forEach((img) => {
            img.crop.lock = true;
            img.crop.percentage = 123 / 218;
          });
        }
        // 获取老media里的裁切比例
        const imgMedia = this.images.find((img) => img.type !== 2);
        let percentage = getImageCropPercentage({
          model: imgMedia.crop,
        });
        // 如果是story则重置比例
        if (this.story) {
          percentage = 123 / 218;
        }
        await setCropImages({ images: result, percentage });
        // 判断如果是由1个到多个则清空所有tag
        if (result.length > 1) {
          result.forEach((i) => {
            i.product_tags = [];
            i.usertags = [];
          });
        }
        this.$set(this.$parent, "images", result);
        this.editModal = false;
      } catch (e) {
        showErrorMsg(e);
      } finally {
        loading.close();
      }
    },
    /**
     * bulk时保存
     */
    cropSaveClick() {
      this.$parent.info.images = this.$parent.images;
      this.$parent.close();
    },
    /**
     * 加载media更多
     * @returns {Promise.<void>}
     */
    async loadMoreMedia(first) {
      try {
        this.mediaListLoading = true;
        await loadMore({ first });
      } catch (e) {
        showErrorMsg(e);
      } finally {
        this.mediaListLoading = false;
      }
    },
  },
  data() {
    return {
      editModal: false,
      uploadModal: false,
      mediaListLoading: false,
      selectIndex: 0,
      copy: [],
      menus: [
        {
          // upload菜单
          id: "computer",
          image: "computer",
          text: "Upload From Computer",
        },
        {
          id: "dropbox",
          image: "dropbox",
          text: "Upload From Dropbox",
        },
        {
          id: "drive",
          image: "drive",
          text: "Upload From Google Drive",
        },
      ],
    };
  },
  computed: {
    twitter() {
      return this.publisherList[0].socialNetwork === 4;
    },
    only() {
      return !this.$parent.showMainFormModal;
    },
    ...mapGetters({
      mediaLibraryList: MEDIA_LIBRARY_LIST,
    }),
    /**
     * 通过判断表单中是否存在视频，如果存在视频则不可编辑
     */
    hasNoVideo() {
      // 遍历选中media，查看是否存在是视频 type = 2
      const media = this.images.find((m) => m.type === 2);
      return media === undefined;
    },
    /**
     * 计算图片选中状态
     * @returns {Array}
     */
    libraries() {
      if (!this.mediaLibraryList) return [];
      const libraries = this.mediaLibraryList.list.map((m) => {
        let media = {
          ...m,
        };
        this.copy.forEach((i, index) => {
          if (i.id === media.id) {
            media.index = index + 1;
          }
        });
        return media;
      });
      return libraries;
    },
    /**
     * 计算是否为多选
     */
    mul() {
      return this.images.length > 1;
    },
  },
};
</script>
